import Faq from "./Faq"

const FaqPage = () => {
  return <Faq />
}

export default FaqPage